
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
import ApiService from "@/core/services/ApiService";
import TwoFactorAuthModal from "@/components/modals/wizards/TwoFactorAuthModal.vue";
import ClipboardJS from "clipboard";

export default defineComponent({
  name: "referral-details",
  components: { TwoFactorAuthModal },
  setup() {
    const store = useStore();
    const referralDetails = ref([]);
    const copyButtonRef = ref<null | HTMLElement>(null);
    const inputRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      const clipboard = new ClipboardJS(copyButtonRef.value as Element);
      clipboard.on("success", function (e) {
        const buttonCaption = copyButtonRef.value?.innerHTML;
        //Add bgcolor
        inputRef.value?.classList.add("bg-light-success");
        inputRef.value?.classList.add("text-inverse-light-success");

        if (copyButtonRef.value) {
          copyButtonRef.value.innerHTML = "Copied!";
          copyButtonRef.value?.classList.add("bg-success");
          copyButtonRef.value?.classList.add("text-inverse-success");

        }

        setTimeout(function () {
          if (copyButtonRef.value && buttonCaption) {
            copyButtonRef.value.innerHTML = buttonCaption;
          }

          // Remove bgcolor
          inputRef.value?.classList.remove("bbg-light-success");
          inputRef.value?.classList.remove("text-inverse-light-success");
        }, 3000); // 3seconds

        e.clearSelection();
      });

      setTimeout(() => {
        referralPayouts();
      }, 1000);
    });

    const referralPayouts = async () => {
      try {
        const { data } = await ApiService.get(
          `users/payouts?customer_id=${store.getters.currentUser.data.customer_id}`
        );
        if (data.success) {
          referralDetails.value = data.data[0];
        } else {
          referralDetails.value = [];
        }
      } catch (e) {
        referralDetails.value = [];
      }
    };

    return {
      referralDetails,
      copyButtonRef,
      inputRef,
    };
  },
});
